module.exports = __webpack_public_path__ + "media/assets/ArrowRightGrey-03c71e25cf995d75cf5a1ecfed8acd05.svg";